import { AppContext, IAppContext } from 'appState/appContext';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';

export const useGoBack = () => {
	const history = useHistory();
	const { pathnamesHistory } = useContext<IAppContext>(AppContext);

	const hasPreviousPathName = pathnamesHistory.length > 1;

	return (fallbackPath: string) => {
		hasPreviousPathName ? history.go(-1) : history.push(fallbackPath);
	};
};
